<template>
    <modal @modal-close="handleClose">

        <div class="modal-wrapper">

            <CloseButton @click="handleClose" />

            <div class="modal-content">

                <input-control :label="$t('Status')">
                <select
                        v-model="temporaryFilters.status" class="w-full form-select" :class="{'empty': temporaryFilters.user === null}">
                            <option :value="null">{{ $t('All notifications') }}</option>
                            <option
                                v-for="(statusName, statusId) in statusFilterOptions"
                                :value="parseInt(statusId)">
                                    {{ statusName }}
                            </option>
                    </select>
                </input-control>

                <input-control-date
                    v-model="temporaryFilters.from"
                    :label="$t('From (date)')"
                />

                <input-control-date
                    v-model="temporaryFilters.to"
                    :label="$t('To (date)')"
                />
            </div>

            <div class="modal-actions-outer-wrapper">
                <div class="modal-actions-inner-wrapper">
                    <button
                        type="button"
                        class="w-full btn btn-default btn-primary w-full medium:w-auto mt-4 medium:mt-0"
                        @click.prevent="handleUpdate"
                        >
                        {{ $t('Save') }}
                    </button>
                </div>
            </div>

        </div>

    </modal>
</template>

<script>
import InputControl from '@mobile/components/Form/InputControl';
import InputControlDate from '@/components/Form/InputControlDate';
import Checkbox from '@mobile/components/Checkbox';
import CloseButton from '@/components/Modals/CloseButton.vue';

export default {

    components: {
 Checkbox, InputControl, InputControlDate, CloseButton
},

    props: {
        filters: {
            type: Object,
            required: true,
        },
    },

    data: () => ({
        temporaryFilters: {},
        statusFilterOptions: {},
    }),

    computed: {
        shouldDisplayUserFilters() {
            return this.$store.getters['authentication/hasPermission']('view-all-inspections');
        },
    },

    created() {
        this.statusFilterOptions = {
            1: this.$t('Unread'),
            2: this.$t('Read'),
        };

        if (this.filters) {
            this.temporaryFilters = {
                ...this.temporaryFilters,
                ...JSON.parse(JSON.stringify(this.filters)),
            };
        }
    },


    methods: {
        handleClose() {
            this.$emit('close');
        },

        handleUpdate(event) {
            this.$emit('update', this.temporaryFilters);
            this.$emit('close');
        },
    },


};
</script>
